module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_santander.112f70e3.svg";